import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { CheckS } from '@lichtblick/photon/icons/symbols/check-s';
import styles from './Confirmation.module.scss';
import formStyles from './Form.module.scss';
export const Confirmation = ({ email, onBackButtonClick })=>/*#__PURE__*/ _jsxs("section", {
        className: styles.container,
        ref: (ref)=>ref?.scrollIntoView({
                block: 'center',
                behavior: 'smooth'
            }),
        children: [
            /*#__PURE__*/ _jsxs(Headline, {
                className: formStyles.headline,
                renderAs: "h2",
                size: "m",
                children: [
                    "Gute Idee! Für Ihr Unter­nehmen und das Klima",
                    /*#__PURE__*/ _jsx(CheckS, {
                        className: styles['check-icon']
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Text, {
                children: [
                    "Danke für die Anfrage. Zur Sicherheit kommt gleich eine E-Mail von LichtBlick an ",
                    /*#__PURE__*/ _jsx("em", {
                        children: email
                    }),
                    ". Die bitte einmal bestätigen und dann meldet sich bald ein*e LichtBlick-Berater*in."
                ]
            }),
            /*#__PURE__*/ _jsx(BoxCTA, {
                as: "button",
                className: styles['back-button'],
                onClick: onBackButtonClick,
                type: "button",
                variant: "neutral-outline",
                children: "Nochmal zurück"
            })
        ]
    });

//# sourceMappingURL=Confirmation.js.map